import {
  InboxCreatedDocument,
  NotificationsViewDataDocument,
} from "#app/lib/data";
import {
  defineSubscription,
  type AnySubscriptionRequest,
} from "#app/lib/subscriptions/subscription-provider";

// One `inboxCreated` event per new notification for the signed-in member.
// The payload carries only the row's scalars (no author or project), so the
// handler bumps the global badge at once and refetches each open Inbox list,
// which then renders the full row. An Inbox opened later fetches on mount
// (cache-and-network), so a list that is not on screen needs nothing here.
//
// Module constant (no parameters), so registration costs nothing per render.
export const INBOX_SUBSCRIPTIONS: AnySubscriptionRequest[] = [
  defineSubscription({
    document: InboxCreatedDocument,
    onData: (client, data) => {
      const newItem = data.inboxCreated?.inbox;
      if (!newItem) return;

      if (!newItem.read) {
        client.cache.modify({
          fields: {
            notificationUnreadCount(existing: number = 0) {
              return existing + 1;
            },
          },
        });
      }
      void client
        .refetchQueries({ include: [NotificationsViewDataDocument] })
        .catch(() => {
          // The list catches up on its next fetch; the badge is already bumped.
        });
    },
  }),
];
